export default "__VITE_ASSET__CLiPAKbL__$_?nuxt_component=async&nuxt_component_name=IconLogoCopilot&nuxt_component_export=default__"